// ----------------------------------------------------------------------------
// Component: Site Navigation
// ----------------------------------------------------------------------------
//
// Leveraging Medium article to make animations "smooth as butter"!
// https://medium.com/outsystems-experts/how-to-achieve-60-fps-animations-with-css3-db7b98610108#.6vf3fxqte
//
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);


module.exports = function() {

    // Open menu on mobile
    $('.header__icon--menu').on('click', function(event) {
        event.preventDefault();

        $('.navigation').toggleClass('is-open');
        $('.header__icon').toggleClass('is-open');
        $('body').toggleClass('open-nav');

    });


    $('body').on('click', function(event) {
        if (!$(event.target).closest('.navigation__link--dropdown, .navigation__item').length) {
            $('.navigation__item').removeClass('is-open');
        }
    });

    $('.navigation__link--dropdown').on('click', function(event) {
        $dropdown = $(this).closest('.navigation__item');

        if ($dropdown.siblings().hasClass('is-open')) {
            $dropdown.siblings().removeClass('is-open');
            $dropdown.addClass('is-open');
        } else {
            $dropdown.toggleClass('is-open');
        }
    });
};
